<template>
    <div class="page">
        <toolbar-system></toolbar-system>
        <v-container>
            <v-layout>
                <v-flex xl4>
                    <v-card>
                        <v-card-title>Status dos alunos</v-card-title>
                        <v-card-text>
                            <apexchart class="chart" type="line" :options="options" :series="series"></apexchart>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import ToolbarSystem from '../../components/ToolbarSystem'
export default {
    components:{
        ToolbarSystem
    },
    data () {
        return{
            options:{},
            series: [{
                name: 'Alunos',
                data:[44, 55, 41, 17, 15]
            }],
            xaxis: {
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
            }
        }
    },
    methods:{
        
    }
}
</script>
<style>
    .chart{
        width: auto !important;
    }
</style>

